import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router-dom'

const activeClassName = 'ACTIVENAV'


const Box = styled.div`
  width: 414px;
  min-width: 414px;
  height: 543px;
  border-radius: 28px;
  overflow: hidden;

  &.${activeClassName}{
    height: 621px;
    ${({ theme }) => theme.mediaWidth.upToExtraSmall`
      height: 494px;
    `};
  };
  
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 414px;
    min-width: 414px;
    height: 532px;
    margin: auto;
  `};
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 331px;
    min-width: 331px;
    height: 425px;
    margin: auto;
  `};
`
const BgImg = styled.div<{bg: string}>`
  width: 100%;
  height: 100%;
  background: url('${({bg}) => bg ? bg : ''}');
  background-size: cover;
`

export default function ImgBox ({imgLink}: {imgLink: string}) {
  const location = useLocation()
  return (
    <Box className={location.pathname.indexOf('gamification/poker') > -1 ? activeClassName : ''}>
      <BgImg bg={imgLink} />
    </Box>
  )
}